/**
 * @description 多语言
 * @author wangfupeng
 */

import { i18nAddResources } from '@wangeditor/editor'

i18nAddResources('en', {
  attachment: {
    upload: 'Upload Attachment',
    download: 'Download Attachment',
  },
})

i18nAddResources('zh-CN', {
  attachment: {
    upload: '上传附件',
    download: '下载附件',
  },
})
